export default "__VITE_ASSET__FXBNS5Eb__"